import { useSignal } from '@preact/signals'
import { clsx } from 'clsx'

import { Typography, Button, CloseXIcon } from 'components'

const PendingInvitationCard = ({
	pendingInvitation,
	handleAcceptInvitation,
	handleRejectInvitation
}: {
	pendingInvitation: string
	handleAcceptInvitation: (projectId: string) => void
	handleRejectInvitation: (projectId: string) => void
}) => {
	const isInvitationInProgress = useSignal(false)

	return (
		<section class='mb-5'>
			<div class='relative flex items-center justify-between gap-4 rounded-md bg-black-800 p-6'>
				<div>
					<Typography
						class='text-[1.125rem] leading-[1.575rem]'
						color='text-black-100'
						text="You're invited to collaborate on"
						variant='h4'
						weight='font-semibold'
					/>
					<Typography
						class='text-[1.125rem] leading-[1.575rem]'
						color='text-product'
						text={`${pendingInvitation}`}
						variant='h4'
						weight='font-semibold'
					/>
				</div>
				<Button
					className='mr-6 min-w-28 '
					disabled={isInvitationInProgress.value}
					isLoading={isInvitationInProgress.value}
					onClick={() => {
						isInvitationInProgress.value = true
						handleAcceptInvitation(pendingInvitation)
					}}
					text='Collaborate'
				/>
				<button
					aria-label={`Reject invitation for ${pendingInvitation}`}
					class={clsx(
						'absolute right-[15px] top-[15px] z-10 h-[0.875rem] w-[0.875rem]',
						isInvitationInProgress.value
							? 'text-black-400'
							: 'text-black-100 transition-opacity duration-100 hover:text-black-200'
					)}
					disabled={isInvitationInProgress.value}
					onClick={() => {
						handleRejectInvitation(pendingInvitation)
					}}
					type='button'
				>
					<CloseXIcon />
				</button>
			</div>
		</section>
	)
}

export { PendingInvitationCard }
